import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, ITrainingCategoryUpsert, ITrainingCategory, IGetPutRequest } from '../../interfaces'

const getUpdateTrainingCategoryMutationRequest: IGetPutRequest = params => {

  return {
    method: 'put',
    url: `${config.baseUrl}/TrainingCategories/`,
  }
}

const useUpdateTrainingCategoryMutation: IUseUpdateMutation<ITrainingCategory, ITrainingCategoryUpsert> = (params, options = {}) => {
  const request = useMemo(() => getUpdateTrainingCategoryMutationRequest(params), [params])

  const updateTraining: IUpdateFn<ITrainingCategoryUpsert, ITrainingCategory> = useCallback(
    async data => {
      return axios({ ...request, url: request.url + data.id, data }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingCategory, Error, any>({
    mutationFn: updateTraining,
    ...options,
  })

  return response
}

export default useUpdateTrainingCategoryMutation
